import React, { useState } from "react";
import CoinPng from "assets/images/coin-shadow.png";
import screenPng from "assets/images/screenshop.png";
import Layout from "../components/Layout/Layout";
import FormResetPassword from "./components/FormResetPassword/FormResetPassword";
import homeImg from '../../../assets/images/home-svg.jpg';
import { BORROWER_ONBOARDING_URL } from "@common/config/environments";

const ResetPassword = () => {
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [email, setEmail] = useState<string|null>(null);
  
  const title = !isSubmitted ?
  "Forgot your password?"
  :
  "Check your email"

  const subtitle = !isSubmitted ?
  "Enter your email and we’ll send you a link to reset it"
  :
  <>We sent a password reset link to <b>{email}</b></>

  return (
    <Layout>
      <div className="Login ResetPassword">
        <div className="Login-colum"></div>
        <div className="Login-form">
          <h1 className="h1">{title}</h1>
          <p className="subtitle subtitle--reset-password">{subtitle}</p>
          <FormResetPassword {...{ isSubmitted, setIsSubmitted, email, setEmail }}/>
          <a
            className="body-regular link-absolute"
            href={`${BORROWER_ONBOARDING_URL}/`}
            rel="noopener noreferrer"
          >
            Don&apos;t have an account?{" "}
            <span className="body-regular-bold">Price your first loan</span>
          </a>
        </div>
        <div className="right">
          <div className="content">
            <div>
              <img className="star" src="https://storage.googleapis.com/constlending-borrowers/static/star-vector.svg" />
            </div>
            <p className="phrase">
              &quot;Dealing with multiple lenders is exhausting and wondering if I&apos;d get financing made me apprehensive about chasing deals. Thanks to you, I can just focus on buying properties!&quot;
            </p>
            <div className="author">
              <b>Chandra M</b>
              <br></br>
              Real estate investor
            </div>
          </div>
          <div>
            <img className="home" src={homeImg} />
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default ResetPassword;
